import { createSlice } from '@reduxjs/toolkit';
import { resetStore, resetStoreNoReload } from './loaderSlice';
const initialState = {
    snackBarMsg: '',
    versionMismatch: false,
    percentageData: [],
    pendingMovedToUnderReviewPopup: null,
};
export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setSnackBarMsg: (state, action) => {
            state.snackBarMsg = action.payload;
        },
        setVersionMismatch: (state, action) => {
            state.versionMismatch = action.payload;
        },
        updateUploadPercentage: (state, action) => {
            state.percentageData = action.payload;
        },
        clearUploadPercentage: (state) => {
            state.percentageData = [];
        },
        setPendingMovedToUnderReviewPopup: (state, action) => {
            state.pendingMovedToUnderReviewPopup = action.payload;
        },
        clearPendingMovedToUnderReviewPopup: (state) => {
            state.pendingMovedToUnderReviewPopup = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetStore, () => initialState);
        builder.addCase(resetStoreNoReload, () => initialState);
    },
});
export const { setSnackBarMsg, setVersionMismatch, updateUploadPercentage, clearUploadPercentage, setPendingMovedToUnderReviewPopup, clearPendingMovedToUnderReviewPopup, } = uiSlice.actions;
export default uiSlice.reducer;
